/**
 * Named layout max-widths aligned to MUI breakpoint values (md/lg/xl).
 *
 * content (900 / md) — single-column forms, settings, card lists
 * page    (1200 / lg) — dashboards, tabbed workspaces, app shells
 * wide    (1536 / xl) — dense tables, multi-pane layouts
 *
 * Leave uncapped (none) for full-bleed ops tools (kanban, inbox, CRM tables).
 * Prose/reading measures (~700–800) stay separate; do not force into these roles.
 */
export const layoutWidths = {
  content: 900,
  page: 1200,
  wide: 1536,
};
